module.exports = __webpack_public_path__ + "account/assets/ok.6963c805.svg";